import { z } from 'zod';

const basePageInfo = z.object({
    url: z.string(),
    locale: z.string().optional(),
    currency: z.string().optional()
});

export const indexPageInfo = z.intersection(
    z.object({
        type: z.literal('index')
    }),
    basePageInfo
);

export const productPageInfo = z.intersection(
    z.object({
        type: z.literal('product'),
        productId: z.string()
    }),
    basePageInfo
);

export const cartPageInfo = z.intersection(
    z.object({
        type: z.literal('cart')
    }),
    basePageInfo
);

export const checkoutPageInfo = z.intersection(
    z.object({
        type: z.literal('checkout')
    }),
    basePageInfo
);

export const collectionPageInfo = z.intersection(
    z.object({
        type: z.literal('collection'),
        collectionId: z.string()
    }),
    basePageInfo
);

export const listCollectionsPageInfo = z.intersection(
    z.object({
        type: z.literal('list-collections')
    }),
    basePageInfo
);

export const contactPageInfo = z.intersection(
    z.object({
        type: z.literal('contact')
    }),
    basePageInfo
);

export const faqPageInfo = z.intersection(
    z.object({
        type: z.literal('faq')
    }),
    basePageInfo
);

export const profilePageInfo = z.intersection(
    z.object({
        type: z.literal('profile')
    }),
    basePageInfo
);

export const ordersPageInfo = z.intersection(
    z.object({
        type: z.literal('orders')
    }),
    basePageInfo
);

export const orderPageInfo = z.intersection(
    z.object({
        type: z.literal('order'),
        orderId: z.string()
    }),
    basePageInfo
);

export const loginPageInfo = z.intersection(
    z.object({
        type: z.literal('login')
    }),
    basePageInfo
);

export const registerPageInfo = z.intersection(
    z.object({
        type: z.literal('register')
    }),
    basePageInfo
);

export const searchPageInfo = z.intersection(
    z.object({
        type: z.literal('search'),
        searchText: z.string()
    }),
    basePageInfo
);

export const notFoundPageInfo = z.intersection(
    z.object({
        type: z.literal('not-found')
    }),
    basePageInfo
);

export const policyPageInfo = z.intersection(
    z.object({
        type: z.literal('policy'),
        policyTitle: z.string()
    }),
    basePageInfo
);

export const articlePageInfo = z.intersection(
    z.object({
        type: z.literal('article'),
        articleTitle: z.string()
    }),
    basePageInfo
);

export const blogPageInfo = z.intersection(
    z.object({
        type: z.literal('blog'),
        blogTitle: z.string()
    }),
    basePageInfo
);

export const generalPageInfo = z.intersection(
    z.object({
        type: z.literal('general')
    }),
    basePageInfo
);

export const pageInfo = z.union([
    indexPageInfo,
    productPageInfo,
    cartPageInfo,
    checkoutPageInfo,
    collectionPageInfo,
    listCollectionsPageInfo,
    contactPageInfo,
    faqPageInfo,
    profilePageInfo,
    ordersPageInfo,
    orderPageInfo,
    loginPageInfo,
    registerPageInfo,
    searchPageInfo,
    notFoundPageInfo,
    policyPageInfo,
    articlePageInfo,
    blogPageInfo,
    generalPageInfo
]);
